import script from "./WithdrawInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawInfo.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawInfo.vue?vue&type=style&index=0&id=36f7a7c6&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f7a7c6"]])

export default __exports__